module.exports = __webpack_public_path__ + "static/img/03best.5a197dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/sport/07sportIndex/03best.png
// module id = dEI9
// module chunks = 0